var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor-canvas"},[_c('canvas',{attrs:{"id":`canvas-editor-${_vm.index}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }